import { useState } from 'react'
import { Calendar, Award, Star, Presentation, Mic, Wrench, Home, MapPin, Mail, Phone, Send, CheckCircle2, Youtube } from 'lucide-react'
import { IoLogoWhatsapp, IoLogoInstagram, IoLogoTiktok, IoLogoFacebook } from 'react-icons/io5'
import { ASSETS, WA_NUMBER } from '../constants.js'

/* ── About ── */
export function AboutSectionPreview({ aboutImages }) {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-3 sm:px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-2xl xs:text-3xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-gray-800 leading-tight">
              About <span className="text-blue-600">ASA HIKARI MULYA</span>
            </h2>
            <p className="text-sm xs:text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              Misi Kami Menjadi Jembatan Karir Anda — menjadi jembatan bagi para pencari kerja Indonesia untuk meraih impian berkarir di Jepang dengan bekal kompetensi bahasa, skill, dan etos kerja yang tinggi sesuai standar industri Jepang.
            </p>
            <ul className="space-y-3 mt-4 text-gray-700 text-sm sm:text-base">
              {['Kurikulum Terstandar', 'Instruktur Berpengalaman', 'Jaringan Perusahaan Luas'].map((t) => (
                <li key={t} className="flex items-start gap-3">
                  <span className="text-blue-600 text-lg mt-0.5">✓</span>
                  <span><span className="font-bold text-gray-900">{t}</span>{t === 'Kurikulum Terstandar' ? ' – Pembelajaran bahasa Jepang setara JF-Test A2 dan skill SSW.' : t === 'Instruktur Berpengalaman' ? ' – Pengajar profesional dari praktisi dan ahli bahasa.' : ' – Kesempatan wawancara langsung dengan perusahaan Jepang.'}</span>
                </li>
              ))}
            </ul>
            <button className="mt-4 flex items-center gap-x-2 bg-blue-600 hover:bg-blue-700 transition-all text-white px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base font-semibold rounded-tr-2xl rounded-bl-2xl w-auto">
              Read More
            </button>
          </div>
          <div className="order-1 lg:order-2">
            <div className="block md:hidden space-y-4">
              <div className="w-full flex justify-center"><img src={aboutImages[0]} alt="" className="w-full max-w-xs object-contain rounded-md shadow-md" /></div>
              <div className="grid grid-cols-2 gap-3">
                <img src={aboutImages[1]} alt="" className="w-full object-cover rounded-md shadow-md" />
                <img src={aboutImages[2]} alt="" className="w-full object-cover rounded-md shadow-md" />
              </div>
            </div>
            <div className="hidden md:grid grid-cols-2 gap-4 lg:gap-6 p-2 sm:p-4">
              <div className="flex flex-col space-y-4 lg:space-y-5 mt-32 sm:mt-80 lg:mt-72">
                <img src={aboutImages[1]} alt="" className="w-full h-16 sm:h-20 md:h-24 lg:h-[18vh] object-cover rounded-lg rounded-tl-[2rem] lg:rounded-tl-[3.1rem] shadow-lg" />
                <img src={aboutImages[2]} alt="" className="w-full h-24 sm:h-28 md:h-32 lg:h-full object-cover rounded-lg rounded-br-[2rem] lg:rounded-br-[3.1rem] shadow-lg" />
              </div>
              <div className="flex justify-center items-center w-full">
                <img src={aboutImages[0]} alt="" className="w-full max-w-sm md:max-w-md lg:max-w-lg h-64 sm:h-80 md:h-[40vh] lg:h-[50vh] object-cover rounded-xl shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

/* ── Clients ── */
export function ClientSectionPreview({ clientLogos }) {
  return (
    <section className="bg-white w-full pb-12">
      <div className="text-center py-8">
        <span className="text-xl sm:text-2xl md:text-3xl font-bold text-blue-950">Mitra Kami</span>
      </div>
      <div className="flex justify-center flex-wrap gap-8 px-4 sm:px-8 md:px-12 lg:px-16 max-w-7xl mx-auto">
        {clientLogos.map((c) => (
          <div key={c.id} className="flex flex-col gap-y-3 items-center justify-center w-full max-w-[140px]">
            <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 flex items-center justify-center">
              <img className="w-full h-full object-contain" src={c.logo} alt={c.name} />
            </div>
            <span className="font-semibold text-blue-950 text-xs sm:text-sm md:text-base text-center px-2">{c.name}</span>
          </div>
        ))}
      </div>
    </section>
  )
}

/* ── Schedule / Kelas ── */
export function ScheduleSectionPreview({ kelasData }) {
  return (
    <section className="py-10 sm:py-12 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <div className="text-blue-500 text-xs sm:text-sm font-medium mb-2">Kelas Terbaik Asa Hikari Mulya</div>
          <h2 className="text-xl xs:text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 text-gray-800 px-2">Kelas BASIC adalah Kelas Terbaik di Asa Hikari Mulya</h2>
          <h3 className="text-base xs:text-lg sm:text-xl text-blue-600 font-semibold mb-4 sm:mb-6">MENGAPA DEMIKIAN ?</h3>
          <p className="text-gray-600 text-xs xs:text-sm sm:text-base max-w-6xl mx-auto leading-relaxed mb-3 sm:mb-4 px-2">
            Di Kelas BASIC, Para Peserta Didik Mendapatkan Berbagai Materi Pendidikan yang Menjadi Persyaratan untuk Mengikuti Program SSW (Specified Skill Worker) diantaranya Kurikulum Pendidikan Kemampuan Bahasa Jepang JF-Test A2 dan Kurikulum Pendidikan Skill SSW di Berbagai Bidang.
          </p>
          <p className="text-gray-600 text-xs xs:text-sm sm:text-base max-w-6xl mx-auto leading-relaxed px-2">
            Dan yang Lebih Menariknya Peserta Didik kelas BASIC akan dikutsertakan dalam Wawancara Bersama Pihak User JEPANG untuk Penempatan Kerja di Berbagai Wilayah yang ada di Jepang.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 mb-8 sm:mb-10 md:mb-12">
          {kelasData.map((item) => (
            <div key={item.id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow">
              <div className="relative h-36 xs:h-40 sm:h-48 bg-gradient-to-br from-blue-100 to-blue-200 mb-4 sm:mb-6">
                <div className="absolute inset-0 flex items-center justify-center">
                  <img src={item.image_url} alt={item.title} className="w-full h-full object-cover" />
                </div>
                <div className="absolute top-2 sm:top-3 right-2 sm:right-3 flex flex-col sm:flex-row gap-1 sm:gap-2">
                  <div className="bg-gray-600 text-white text-[10px] xs:text-xs px-1.5 xs:px-2 py-0.5 xs:py-1 rounded flex items-center gap-0.5 xs:gap-1">
                    <Calendar className="w-2.5 h-2.5" /><span className="whitespace-nowrap">{item.duration}</span>
                  </div>
                  {item.certified && (
                    <div className="bg-blue-600 text-white text-[10px] xs:text-xs px-1.5 xs:px-2 py-0.5 xs:py-1 rounded flex items-center gap-0.5 xs:gap-1">
                      <Award className="w-2.5 h-2.5" /><span className="whitespace-nowrap">Bersertifikat</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="p-4 sm:p-5 md:p-6">
                <h3 className="text-base xs:text-lg font-semibold text-gray-800 mb-2 sm:mb-3">{item.title}</h3>
                <p className="text-gray-600 text-xs xs:text-sm leading-relaxed mb-3 sm:mb-4">{item.deskripsi}</p>
                <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-3 sm:mb-4">
                  {(item.kategori || []).slice(0, 3).map((tag, i) => (
                    <span key={i} className="text-[10px] xs:text-xs bg-gray-100 text-gray-700 px-1.5 xs:px-2 py-0.5 xs:py-1 rounded-full">{tag}</span>
                  ))}
                  {(item.kategori || []).length > 3 && <span className="text-[10px] xs:text-xs text-gray-500">+{(item.kategori || []).length - 3} lainnya</span>}
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2 mb-3 sm:mb-4">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className={`w-3 h-3 xs:w-3.5 xs:h-3.5 sm:w-4 sm:h-4 ${i < Math.floor(item.rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />
                    ))}
                  </div>
                  <span className="text-xs xs:text-sm text-gray-600">{item.rating}</span>
                </div>
                <div className="text-center mt-4 sm:mt-6 md:mt-8">
                  <button className="group relative bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold py-2 px-4 sm:px-8 rounded-full shadow-lg shadow-blue-500/30 transition-all duration-300 inline-flex items-center justify-center gap-2 hover:scale-105 overflow-hidden">
                    <span className="relative text-sm sm:text-base">Daftar</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:w-5 sm:h-5 relative transition-transform group-hover:translate-x-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8 sm:mt-10 md:mt-12">
          <button className="group relative bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold py-2 px-3 sm:px-8 rounded-tr-2xl rounded-bl-2xl shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-600/40 transition-all duration-300 inline-flex items-center gap-2 hover:scale-105 overflow-hidden">
            <span className="relative text-sm sm:text-base">Lihat Lowongan Pekerjaan</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:w-5 sm:h-5 relative transition-transform group-hover:translate-x-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  )
}

/* ── Facilities ── */
const FACILITIES = [
  { icon: <Presentation size={40} className="text-blue-600" />, title: 'Ruang Kelas Modern', desc: 'Kelas nyaman ber-AC dilengkapi dengan perangkat multimedia untuk menunjang pembelajaran.' },
  { icon: <Mic size={40} className="text-blue-600" />, title: 'Laboratorium Bahasa', desc: 'Fasilitas untuk melatih kemampuan mendengar (choukai) dan berbicara (kaiwa) secara intensif.' },
  { icon: <Wrench size={40} className="text-blue-600" />, title: 'Ruang Praktik Skill', desc: 'Tempat khusus untuk simulasi keterampilan kerja sesuai bidang SSW yang dipilih.' },
  { icon: <Home size={40} className="text-blue-600" />, title: 'Asrama Peserta', desc: 'Akomodasi yang aman dan nyaman bagi peserta didik dari luar kota.' },
]

export function FacilitiesSectionPreview() {
  return (
    <section className="py-16 px-4 bg-gray-100">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-blue-900 mb-4">Fasilitas Pendukung Lengkap</h2>
        <p className="text-gray-600 mb-12 text-sm sm:text-base">Kami menyediakan lingkungan belajar yang nyaman dan kondusif untuk kesuksesan Anda.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FACILITIES.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center text-center hover:shadow-lg cursor-pointer">
              <div className="mb-4">{f.icon}</div>
              <h3 className="text-lg font-bold text-blue-800 mb-2">{f.title}</h3>
              <p className="text-gray-600 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

/* ── Team ── */
export function TeamSectionPreview({ teamImages }) {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-50 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-72 h-72 bg-blue-200/20 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-blue-300/10 rounded-full blur-3xl" />
      </div>
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-blue-100 text-blue-600 rounded-full text-xs sm:text-sm font-semibold mb-4 tracking-wide">TIM TERBAIK KAMI</span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-3 sm:mb-4 px-2">
            <span className="bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">Talenta Terbaik Kami</span>
          </h1>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto leading-relaxed px-2">Figur-figur inspiratif yang menjadi bukti nyata dari komitmen dan kualitas kami</p>
        </div>
        <div className="hidden lg:block relative max-w-6xl mx-auto">
          <div className="absolute top-16 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-300 to-transparent z-0 rounded-full" />
          <div className="overflow-hidden px-16">
            <div className="flex" style={{ width: `${teamImages.length * 33.33}%` }}>
              {teamImages.map((step, index) => (
                <div key={step.id || index} className="flex flex-col items-center px-4 flex-shrink-0 pb-10" style={{ width: '33.33%' }}>
                  <div className={`w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl my-8 z-10 bg-gradient-to-br ${index === 0 ? 'from-blue-600 to-blue-700 shadow-xl shadow-blue-500/50 scale-110' : 'from-blue-500 to-blue-600 shadow-lg scale-100'}`}>
                    <span>{step.subtitle ? String(index + 1).padStart(2, '0') : '01'}</span>
                  </div>
                  <div className="bg-white/80 backdrop-blur-sm rounded-2xl w-full max-w-sm mx-auto overflow-hidden border border-gray-200/50 shadow-lg" style={{ minHeight: '280px' }}>
                    <div className="w-full h-72 bg-gradient-to-br from-blue-100 via-blue-50 to-gray-100 relative overflow-hidden">
                      {step.url && <img src={step.url} alt={step.subtitle} className="w-full h-full object-contain object-center" />}
                    </div>
                    <div className="p-6">
                      <div className="inline-block px-3 py-1 bg-blue-50 text-blue-600 rounded-lg text-xs font-semibold mb-3">{step.title}</div>
                      <h3 className="text-lg font-bold text-gray-800 mb-2 text-center">{step.subtitle}</h3>
                      <p className="text-sm text-gray-600 leading-relaxed text-center italic">{step.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="lg:hidden relative">
          <div className="grid grid-cols-2 gap-3">
            {teamImages.map((step) => (
              <div key={step.id || `mob-${step.title}`}>
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-200/50 overflow-hidden">
                  <div className="w-full h-40 sm:h-52 bg-gradient-to-br from-blue-100 via-blue-50 to-gray-100 relative overflow-hidden">
                    {step.url && <img src={step.url} alt={step.subtitle} className="w-full h-full object-contain object-center" />}
                  </div>
                  <div className="p-3 sm:p-4">
                    <div className="inline-block px-2 py-0.5 bg-blue-50 text-blue-600 rounded-lg text-[10px] font-semibold mb-1">{step.title}</div>
                    <h3 className="text-xs sm:text-sm font-bold text-gray-800 mb-1">{step.subtitle}</h3>
                    <p className="text-[10px] sm:text-xs text-gray-600 leading-relaxed italic line-clamp-2">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-center mt-8 sm:mt-10 md:mt-12">
          <button className="group relative bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold py-3 px-6 sm:px-8 rounded-tr-2xl rounded-bl-2xl shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-600/40 transition-all duration-300 inline-flex items-center gap-2 hover:scale-105 overflow-hidden">
            <span className="relative text-sm sm:text-base">Lihat Selengkapnya</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:w-5 sm:h-5 relative transition-transform group-hover:translate-x-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  )
}

/* ── Gallery ── */
export function GallerySectionPreview({ galleryImages }) {
  return (
    <section className="py-16 px-4 bg-gray-100">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-blue-900 mb-4">Galeri</h2>
        <p className="text-gray-600 mb-12 text-sm sm:text-base">Momen-momen berharga dari proses pembelajaran hingga keberhasilan alumni kami.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((item) => (
            <div key={item.id} className="relative overflow-hidden rounded-2xl shadow-md group">
              <img src={item.url} alt={item.title} className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-blue-900/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-start p-4 rounded-2xl">
                <p className="text-white font-semibold">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

/* ── CTA ── */
export function CTASectionPreview() {
  return (
    <section className="py-4 sm:py-6 md:py-8 bg-gradient-to-br from-gray-50 via-blue-50/20 to-gray-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6">
        <div className="rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl relative">
          <div className="relative min-h-[250px] sm:min-h-[280px] md:min-h-[320px] bg-cover bg-center" style={{ backgroundImage: `url('${ASSETS.bgHero1}')` }}>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-800/90 to-blue-900/80" />
            <div className="absolute top-10 right-20 w-2 h-2 bg-blue-300/40 rounded-full animate-pulse" />
            <div className="absolute bottom-20 right-40 w-1.5 h-1.5 bg-orange-300/30 rounded-full animate-pulse" />
            <div className="absolute top-1/3 right-10 w-1 h-1 bg-blue-200/30 rounded-full animate-pulse" />
            <div className="absolute inset-0 flex items-center">
              <div className="w-full">
                <div className="flex flex-col lg:flex-row items-center justify-between min-h-[250px] sm:min-h-[280px] md:min-h-[320px]">
                  <div className="flex-1 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-6 sm:py-8 md:py-10 text-white text-center lg:text-left max-w-3xl">
                    <div className="backdrop-blur-sm bg-white/5 rounded-2xl p-4 sm:p-5 md:p-6 border border-white/10">
                      <h2 className="text-base xs:text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-3xl font-bold mb-2 sm:mb-3 leading-tight">
                        Jangan lewatkan kesempatan emas ini!
                        <span className="block mt-1 bg-gradient-to-r from-orange-300 to-orange-400 bg-clip-text text-transparent">Bergabunglah dengan Asa Hikari Mulya</span>
                      </h2>
                      <p className="text-[11px] xs:text-xs sm:text-sm md:text-base mb-3 sm:mb-4 md:mb-5 text-blue-50 leading-relaxed">
                        Raih sukses karirmu di Jepang! <span className="font-semibold text-orange-200 ml-1">Kursi Kami terbatas!</span>
                      </p>
                      <button className="group relative bg-gradient-to-r from-orange-500 via-orange-600 to-orange-500 hover:from-orange-600 hover:via-orange-700 hover:to-orange-600 text-white px-4 xs:px-5 sm:px-6 py-2 sm:py-2.5 md:py-3 text-[11px] xs:text-xs sm:text-sm font-bold rounded-xl transition-all duration-300 inline-flex items-center gap-1.5 shadow-lg shadow-orange-500/40 hover:shadow-xl hover:shadow-orange-600/50 hover:scale-105 overflow-hidden border border-orange-400/50">
                        <span className="relative">Gabung Sekarang!</span>
                        <span className="text-sm">→</span>
                      </button>
                    </div>
                  </div>
                  <div className="hidden lg:block lg:flex-shrink-0 self-stretch relative h-full flex items-center">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-800/80 via-blue-800/40 to-transparent z-10" />
                    <img src={ASSETS.imgPanjang} alt="" className="h-full w-56 xl:w-64 object-cover object-center" />
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute top-0 right-0 w-32 sm:w-40 h-32 sm:h-40 bg-orange-500/5 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-40 sm:w-48 h-40 sm:h-48 bg-blue-500/5 rounded-full blur-3xl" />
          </div>
        </div>
      </div>
    </section>
  )
}

/* ── Contact ── */
const CONTACT_INFO = [
  { icon: MapPin, title: 'Alamat Kami', content: 'Jl. Batoro Katong, Nomor 22, Kelurahan Nologaten, Kecamatan Ponorogo, Kabupaten Ponorogo, Kode Pos 63411' },
  { icon: Mail, title: 'Email', content: 'asahikarimulya82@gmail.com' },
  { icon: Phone, title: 'Telepon / WhatsApp', content: '+6281 395 554 334' },
]

export function ContactSectionPreview() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [formData, setFormData] = useState({ name: '', email: '', whatsapp: '', program: '', message: '' })
  const handleChange = (e) => setFormData((f) => ({ ...f, [e.target.name]: e.target.value }))
  const handleSubmit = (e) => {
    e.preventDefault(); setIsSubmitting(true)
    setTimeout(() => {
      setIsSubmitting(false)
      const msg = `Halo, saya *${formData.name}*.\nBerikut data diri dan pesan saya:\n\n*Email:* ${formData.email}\n*Program:* ${formData.program}\n*Pesan:* ${formData.message}\n\nMohon konfirmasi lebih lanjut. Terima kasih`
      window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank')
      setIsSuccess(true)
      setTimeout(() => { setIsSuccess(false); setFormData({ name: '', email: '', whatsapp: '', program: '', message: '' }) }, 3000)
    }, 1500)
  }

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-50 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-blue-200/20 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-blue-300/15 rounded-full blur-3xl" />
      </div>
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-blue-100 text-blue-600 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4 tracking-wide">HUBUNGI KAMI</span>
          <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">Kontak & Pendaftaran</span>
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto leading-relaxed px-2">Hubungi kami untuk informasi lebih lanjut atau langsung daftar program pelatihan</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-10">
          <div className="space-y-4 sm:space-y-6">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-gray-200/50 shadow-lg">
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-4 sm:mb-6">Informasi Kontak</h3>
              <div className="space-y-4 sm:space-y-5">
                {CONTACT_INFO.map((item, i) => {
                  const Icon = item.icon
                  return (
                    <div key={i}>
                      <div className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 rounded-xl">
                        <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/30">
                          <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-xs sm:text-sm font-semibold text-gray-500 mb-1">{item.title}</h4>
                          <p className="text-sm sm:text-base text-gray-800 font-medium">{item.content}</p>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div
              className="flex items-center justify-center gap-x-2 text-blue-600/80 bg-white rounded-2xl p-4 sm:p-6 shadow-lg cursor-pointer select-none hover:shadow-xl hover:scale-[1.02] transition-all"
              onClick={() => window.open(`https://wa.me/${WA_NUMBER}?text=Halo%20Admin%20Asa%20hikari%20Mulya.`, '_blank')}
            >
              <IoLogoWhatsapp className="text-2xl text-green-500" />
              <span className="text-blue-900 font-bold">Hubungi Kami</span>
            </div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-gray-200/50 shadow-lg">
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2">Form Pendaftaran</h3>
            <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-6">Isi form di bawah untuk mendaftar atau konsultasi</p>
            {isSuccess ? (
              <div className="flex flex-col items-center justify-center py-8 sm:py-12">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle2 className="w-8 h-8 sm:w-10 sm:h-10 text-green-600" />
                </div>
                <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-2">Pesan Terkirim!</h4>
                <p className="text-sm sm:text-base text-gray-600 text-center">Kami akan menghubungi Anda segera</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2"><span className="required">Nama Lengkap</span></label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required className="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white" placeholder="Nama Anda" />
                  </div>
                  <div>
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2"><span className="required">Email</span></label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white" placeholder="email@example.com" />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2"><span className="required">Nomor WhatsApp</span></label>
                    <input type="tel" name="whatsapp" value={formData.whatsapp} onChange={handleChange} required className="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white" placeholder="08123456789" />
                  </div>
                  <div>
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2"><span className="required">Pilih Program</span></label>
                    <select name="program" value={formData.program} onChange={handleChange} required className="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white">
                      <option value="">Pilih Program</option>
                      <option value="basic-n4">Kelas Basic N4</option>
                      <option value="basic-n5">Kelas Basic N5</option>
                      <option value="ssw">Program SSW</option>
                      <option value="magang">Program Magang</option>
                      <option value="konsultasi">Konsultasi</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">Pesan Anda</label>
                  <textarea name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 resize-none bg-white" placeholder="Tulis pesan atau pertanyaan Anda..." />
                </div>
                <button type="submit" disabled={isSubmitting} className="w-full group relative bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold py-3 sm:py-4 px-6 rounded-xl shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-600/40 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed overflow-hidden">
                  <span className="absolute inset-0 bg-white/20 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                  <span className="relative flex items-center justify-center gap-2 text-sm sm:text-base">
                    {isSubmitting ? (<><div className="w-4 h-4 sm:w-5 sm:h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />Mengirim...</>) : (<><Send className="w-4 h-4 sm:w-5 sm:h-5" />Kirim Pesan</>)}
                  </span>
                </button>
                <p className="text-[10px] xs:text-xs text-gray-500 text-center">Dengan mengirim form ini, Anda menyetujui untuk dihubungi oleh tim kami</p>
              </form>
            )}
          </div>
        </div>
        <div className="mt-8 sm:mt-10 md:mt-12 bg-gradient-to-r from-blue-50 to-blue-100/50 rounded-2xl p-4 sm:p-6 md:p-8 border border-blue-200/50">
          <p className="text-xs xs:text-sm sm:text-base text-gray-700 text-center leading-relaxed">
            <span className="font-semibold text-blue-700">Catatan : </span>
            Pastikan semua informasi yang Anda berikan sudah benar sebelum mengirim. Kami akan menghubungi Anda melalui email atau WhatsApp yang Anda cantumkan.
          </p>
        </div>
      </div>
    </section>
  )
}

/* ── Footer ── */
export function FooterPreview() {
  return (
    <footer className=" from-blue-900 to-blue-700 bg-gradient-to-br pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <img src={ASSETS.logoDark} alt="Asahikarimulya Logo" className="w-[15%]" />
            </div>
            <p className="leading-relaxed mb-6 text-white">
              Asa Hikari Mulya adalah pusat pelatihan bahasa Jepang terpercaya yang mempersiapkan Anda untuk bekerja di Jepang melalui program Specified Skilled Worker (SSW) dan Magang. Dapatkan pelatihan intensif, sertifikasi resmi, dan penempatan kerja dengan kurikulum berbasis kebutuhan pasar kerja Jepang.
            </p>
            <iframe title="Lokasi Map" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31618.58296907286!2d111.476565!3d-7.86124!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e79a18cbe9a9b4d%3A0xc2a43dddf592cecb!2sPT%20ASA%20HIKARI%20MULYA%20(LPK)!5e0!3m2!1sid!2sid!4v1758374208964!5m2!1sid!2sid" className="border-0" style={{ border: 0 }} allowFullScreen="" loading="lazy" width={320} height={220} referrerPolicy="no-referrer-when-downgrade" />
          </div>
          <div className="text-white">
            <h4 className="text-lg font-bold  mb-4">Menus</h4>
            <ul className="space-y-2">
              <li><a href="#home" className=" hover:text-blue-200 transition-colors">Home</a></li>
              <li><a href="#about" className=" hover:text-blue-200 transition-colors">Kelas</a></li>
              <li><a href="#registration" className=" hover:text-blue-200 transition-colors">Pengajar</a></li>
              <li><a href="#event-info" className=" hover:text-blue-200 transition-colors">Mitra Asa Hikari Mulya</a></li>
            </ul>
          </div>
          <div className="text-white">
            <h4 className="text-lg font-bold  mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="text-blue-50 mt-1 flex-shrink-0" size={16} />
                <p className=" text-sm">Pusat Pelatihan dan Pendidikan Bahasa Serta Budaya Jepang<br />Jl. Batoro Katong, Nomor 22, Kelurahan Nologaten,<br />Kecamatan Ponorogo, Kabupaten Ponorogo, Kode Pos 63411</p>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="text-blue-50" size={16} /><p className=" text-sm">asahikarimulya82@gmail.com</p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="text-blue-50" size={16} /><p className=" text-sm">+6281 395 554 334</p>
              </div>
            </div>
            <div className="mt-6">
              <h5 className="text-md font-semibold text-white mb-3">Follow Us</h5>
              <div className="flex space-x-3">
                <a href="https://www.tiktok.com/@asahikarimulya.official?_t=ZS-8ymiuOWavwu&_r=1" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700 shadow-md transition-colors"><IoLogoTiktok size={16} /></a>
                <a href="https://www.instagram.com/asahikarimulya.official?igsh=bzIwb3gzdXVjY2Iy" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700 shadow-md transition-colors"><IoLogoInstagram size={16} /></a>
                <a href="https://www.facebook.com/profile.php?id=61550357071704" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700 shadow-md transition-colors"><IoLogoFacebook size={16} /></a>
                <a href="https://www.youtube.com/@asahikarimulyaofficiall" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700 shadow-md transition-colors"><Youtube size={16} /></a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 text-white">
          <div className="text-center  text-sm">
            <p>© 2025 Asa Hikari Mulya. All rights reserved. Powered by{' '}
              <a href="#" className="text-white font-semibold hover:text-blue-200">SavanaIt</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
